module.exports = __webpack_public_path__ + "static/img/5.63a9056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/5.jpg
// module id = tKnF
// module chunks = 0